import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CMSService } from 'src/app/services/CMS/cms.service';

@Component({
  selector: 'app-josa-url',
  templateUrl: './josa-url.component.html',
  styleUrls: ['./josa-url.component.css']
})
export class JosaUrlComponent implements OnInit {

  JosaUrlList=[];
  Submitted: boolean = false;
  isCollapsed = true;
  constructor(private cmsservice: CMSService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


    SearchMdel={

    }
  GetAllJosaUrl() {
    this.JosaUrlList = [];
    this.spinnerService.show();
    this.cmsservice.GetAllJosaUrl(JSON.stringify(this.SearchMdel)).subscribe((data: any) => {
      this.JosaUrlList = data.JosaUrlList;
      this.spinnerService.hide();

    });
  };


  WebsiteModel = {
    JOSAURLID: 0,
    Remarks: '',
    JOSAURL:'',
    JOSAURLStausID:0
  }

  ClearWebsite() {
    this.Submitted = false;
    this.WebsiteModel.JOSAURLID = 0;
    this.WebsiteModel.Remarks = '';
    this.WebsiteModel.JOSAURL = ''; 
    this.WebsiteModel.JOSAURLStausID = 0; 
  }


  GetJosaUrlID(obj) {
    this.WebsiteModel.Remarks = '';
    this.WebsiteModel.JOSAURLID = obj.JOSAURLID;
    this.WebsiteModel.JOSAURL = obj.JOSAURL;   
    this.WebsiteModel.JOSAURLStausID=obj.JOSAURLStausID==1?2:3;

  }

  SaveJosaURlStatus(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.cmsservice.SaveJosaURlStatus(JSON.stringify(this.WebsiteModel)).subscribe((data: any) => {
        this.spinnerService.hide();
         if (data.webResponse.Status) {
          this.globalHelper.CheckActionStatus(data);
          this.GetAllJosaUrl();
        }

        this.Submitted = false;

      });
    }
  };

  UpdateModel={
    JOSAURLID:0,
    JOSAURL:'',
  }

  SetJosaUrlID(item) {
    this.UpdateModel.JOSAURLID=item.JOSAURLID;
    this.UpdateModel.JOSAURL=item.JOSAURL;
  }
  UpdateJOSAURL(item){
   this.UpdateModel=item;
    this.spinnerService.show();
    this.cmsservice.UpdateJOSAURL(JSON.stringify(this.UpdateModel)).subscribe((data: any) => {
      this.spinnerService.hide();
       if (data.webResponse.Status) {
        this.globalHelper.CheckActionStatus(data);
        this.GetAllJosaUrl();
      }
    });
  }
  ngOnInit() {
    this.GetAllJosaUrl();   
  }


}

